import React, { useEffect } from "react";
import { Modal, ModalBody } from "react-bootstrap";
import { AdminButton } from "../buttons/versionHistoryBtn";
import "./modal.css";

const EnableDisableModal = ({
  show,
  handleClose,
  id,
  title,
  status,
  enableDisableFunc,
  consumerText = true,
}) => {
  return (
    <Modal
      centered
      show={show}
      onHide={handleClose}
      dialogClassName="my-modal-content col-5 mx-auto ps-sm-5 fn_Nunito"
      contentClassName="my-modal-content "
    >
      <ModalBody>
        <div className="p-2">
          <p className="fn_Nunito fw_700 fs_18 color_262c3d my-2 px-0">
            Are you sure ?
          </p>
          <p className="fn_Nunito fw_400 fs_14 color_747f9e my-2 px-0">
            Do you want to {status ? "disable" : "enable"} this {title}
            {/* {consumerText == true && "It will not visble to consumers ?"} */}
          </p>
          <div className="d-flex justify-content-between mt-4">
            <AdminButton
              width="150px"
              color={status ? "#FF6F5B" : "#24D626"}
              border={status ? "1px solid #FF6F5B" : "1px solid #24D626"}
              onClick={() => enableDisableFunc(id)}
            >
              <span className="m-2">{status ? "DISABLE" : "ENABLE"}</span>
            </AdminButton>
            <AdminButton
              width="150px"
              background="#7065e4"
              color="white"
              onClick={handleClose}
            >
              <span className="m-2">NO</span>
            </AdminButton>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default EnableDisableModal;
